const delay = (ms: any) => new Promise((resolve) => setTimeout(resolve, ms));

export default delay;
